import request from "@/utils/request";
const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST
const Rms_host = process.env.VUE_APP_RMS_API_HOST;
export function getEquipInfoApi() {
  return request({
    url: "?c=rms&a=equip&do=brief-getall",
    method: "get"
  });
}

export function getEquipDynamicInfoApi(data) {
  return request({
    url: "?c=rms&a=equip&do=getfew",
    method: "post",
    data
  });
}

export function getEquipListApi(params) {
  return request({
    url: jsApiHost + "/equip/equip/list",
    method: "get",
    params
  });
}

export function fetchEquipsStateApi(data) {
  return request({
    url: Rms_host + "/equip/getstate",
    method: "post",
    data
  });
}

export function equipGetallApi(params) {
  return request({
    url: jsApiHost + "/equip/equip/getall",
    method: "get",
    params
  });
}
export function equipMapApi(params) {
  return request({
    url: "?c=rms&a=equip&do=map",
    method: "get",
    params
  });
}

export function equipNewAcitveApi(params) {
  return request({
    url: "?c=rms&a=equip&do=new-active",
    method: "get",
    params
  });
}

export function collectionGetAllApi(params) {
  return request({
    url: `${jsApiHost}/collection/getAll`,
    method: "get",
    params
  });
}


export function collectionCountApi(params) {
  return request({
    url: `${jsApiHost}/collection/count`,
    method: "get",
    params
  });
}


export function collectionCancelApi(data) {
  return request({
    url: `${jsApiHost}/collection/cancel`,
    method: "post",
    data
  });
}

export function equipEditApi(data) {
  return request({
    url: Rms_host + '/equip/edit',
    method: 'post',
    data
  })
}

export function listGroupTreeApi(params) {
  return request({
    url: `${jsApiHost}/god/group/listGroupTree`,
    method: "get",
    params
  });
}

export function groupAddApi(data) {
  return request({
    url: `${jsApiHost}/god/group/add`,
    method: "post",
    data
  });
}

export function groupEditApi(data) {
  return request({
    url: `${jsApiHost}/god/group/edit`,
    method: "post",
    data
  });
}

export function groupMoveApi(data) {
  return request({
    url: `${jsApiHost}/god/group/move`,
    method: "post",
    data
  });
}

export function groupDeleteApi(data) {
  return request({
    url: `${jsApiHost}/god/group/delete`,
    method: "post",
    data
  });
}

export function moveEquipToGroupApi(data) {
  return request({
    url: `${jsApiHost}/god/group/moveEquipToGroup`,
    method: "post",
    data
  });
}